module.exports = __webpack_public_path__ + "imgesssyaa/svg/Attachment2.25cff3f3.svg";